<div class="p-2 h-full min-h-0">
  <p-dialog [draggable]="false" [(visible)]="hideGerg" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle"></i> Functionality only available for CO2 based fluids
    <br> <br>
  </p-dialog>

  @if (!isLoading()) {
    <div class="h-full min-h-0">
      <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
      <div class="flex h-full min-h-0 gap-4 overflow-hidden">
        <div class="z-[2] flex-[0.3] min-w-[150px] flex-shrink min-h-0 flex flex-col overflow-hidden">
          <div class="mb-2">
            <p-button class="outlined-button" size="small" icon="pi pi-plus" severity="success" outlined="true" label="Add Choke"
              title="Add Choke" (click)="onAddChoke()" [disabled]="hideGerg"></p-button>
          </div>
          <div class="flex-1 min-h-0 overflow-auto">
            <p-listbox [scrollHeight]="''" [options]="chokeData?.chokes" [(ngModel)]="selectedChoke" optionLabel="name"
              (onChange)="onChokeSelect($event)">

            <ng-template let-choke #item>
              <div class="flex items-center w-full">
                <div class="flex-1 truncate">
                  <span>{{ choke.name }}</span>
                </div>

                <div>
                  <i
                    class="pi pi-trash !text-red-400"
                    title="Delete Choke"
                    (click)="onDeleteChoke(choke)">
                  </i>
                </div>
              </div>
            </ng-template>

            </p-listbox>
          </div>
        </div>

        <div class="flex-[0.7] min-w-0 min-h-0 h-full overflow-hidden">
          <app-choke-data [choke]="selectedChokeDetails$ | async" (chokeUpdate)="saveChoke($event)"
            [disabled]="chokeData?.chokes?.length < 1" [chokesStore]="chokesStore" class="block h-full min-h-0">
          </app-choke-data>
        </div>
      </div>
    </div>
  }
</div>